import { useMemo } from "react";

import { MARKETING_CHANNELS_OPTIONS } from "containers/admin/clients/client/college-profile-page/college-profile-general-details-form.helpers";
import type { StrategyFieldOverrides } from "containers/admin/clients/client/programs-page/program-strategy-form.utils";

import { useCurrentClient } from "hooks/api/use-clients";

import type { ClientOverviewMarketingChannelsDTOChannelsItem } from "generated/schemas";

const MARKETING_CHANNELS_TAB_ID = "available-marketing-channels";
const CHANNEL_FIELD_KEY = "channel";

const NO_COLLEGE_PROFILE_CHANNELS: ClientOverviewMarketingChannelsDTOChannelsItem[] = [];

const formatCollegeProfileChannelsDescription = (
  channels: ClientOverviewMarketingChannelsDTOChannelsItem[],
): string => {
  const labels = MARKETING_CHANNELS_OPTIONS.filter((option) => channels.includes(option.value)).map(
    (option) => option.label,
  );
  const channelsList =
    labels.length > 0 ? new Intl.ListFormat("en", { style: "long", type: "conjunction" }).format(labels) : "none";

  return `Channels configured in College profile: ${channelsList}.`;
};

export const useCollegeProfileMarketingChannelsDescription = (): StrategyFieldOverrides => {
  const client = useCurrentClient();
  const collegeProfileChannels = client.overview?.marketingChannels?.channels ?? NO_COLLEGE_PROFILE_CHANNELS;

  return useMemo(
    () => ({
      [MARKETING_CHANNELS_TAB_ID]: {
        [CHANNEL_FIELD_KEY]: {
          description: formatCollegeProfileChannelsDescription(collegeProfileChannels),
        },
      },
    }),
    [collegeProfileChannels],
  );
};
